import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=c31c5c8e&scoped=true&"
import script from "./Contents.vue?vue&type=script&lang=js&"
export * from "./Contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31c5c8e",
  null
  
)

export default component.exports